const jQuery = window["jQuery"] ?? [];
const varioous = window["varioous"] ?? [];

function setSpinner(el: Element, action = true, append = true) {
  varioous?.loading_cl?.setSpinner(jQuery(el), action, append);
}

export function loadItemsDataContext(this: any, config: any) {
  // TODO [SR]: Support aborting previous fetch requests when multiple fetch requests are triggered (!)
  // const controller = new AbortController();
  // const signal = controller.signal;
  // controller.abort();
  // fetch(url, { signal })

  return {
    defaultItemsPerPage: 0,
    defaultContainerSelector: "",

    currentItemSourceName: "",

    init() {
      const $root = (this as any).$root;
      this.defaultItemsPerPage = Number($root.dataset.itemsPerPage);
      this.defaultContainerSelector = $root.dataset.containerSelector;
    },

    async loadItems($el: HTMLElement) {
      const $root = (this as any).$root;

      if ($el.classList.contains("disabled")) {
        return;
      }

      const containerSelector = $el.dataset.containerSelector || this.defaultContainerSelector;

      const container = ($root.querySelector(containerSelector) ??
        document.body.querySelector(containerSelector)) as HTMLElement;

      if (container == null) {
        return;
      }

      const pluginName = $el.dataset.pluginName;
      const processMode = $el.dataset.processMode;

      const itemsPerPage = Number($el.dataset.itemsPerPage || this.defaultItemsPerPage);
      const fetchPage = Number($el.dataset.fetchPage || 0);

      if ($el.dataset.itemSourceName) {
        this.currentItemSourceName = $el.dataset.itemSourceName;
      }

      if (processMode == "clear") {
        container.innerHTML = "";
      }

      $el.classList.add("disabled");
      setSpinner(container, true);
      let isLoading = true;

      const fetchUrl = $el.dataset.fetchUrl;
      const attributeFieldArrayName = `tx_vayoga_${pluginName}`.toLowerCase();

      const jsonAttributes = {
        [`${attributeFieldArrayName}[itemsPerPage]`]: String(itemsPerPage),
        [`${attributeFieldArrayName}[page]`]: String(fetchPage),
      };

      let content = "";
      try {
        const response = await fetch(fetchUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "text/html",
          },
          body: new URLSearchParams(jsonAttributes),
        });
        content = await response.text();
      } finally {
        isLoading = false;
        setSpinner(container, false);
        $el.classList.remove("disabled");
      }

      if (content != "") {
        if (processMode == "clear") {
          container.innerHTML = content;
        } else {
          if (container.contains($el)) {
            $el.remove();
          }
          container.insertAdjacentHTML("beforeend", content);
        }
      }
    },

    autoloadItemsObserver: new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(async (entry) => {
          if (entry.isIntersecting) {
            const element = entry.target as HTMLElement;
            observer.unobserve(element);
            element.dispatchEvent(new Event("click"));
          }
        });
      },
      { threshold: 1 },
    ),

    registerAutoload(element: HTMLElement) {
      this.autoloadItemsObserver.observe(element);
    },
  };
}
